__webpack_require__.p = "/Tutorials/MapRendering/ptv-vectormap-overlays-react-app/";